import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import StepIndicatorConfig from '../../interfaces/step-indicator-config';
import { MultiStepService } from './services/multi-step.service';
import { of } from 'rxjs';

@Component({
  selector: 'app-multi-step-navigator',
  templateUrl: './multi-step-navigator.component.html',
  styleUrls: ['./multi-step-navigator.component.scss']
})
export class MultiStepNavigatorComponent implements OnInit, OnDestroy {

  @Input()
  steps: StepIndicatorConfig[] = [];

  constructor(
    private multiStepServ: MultiStepService
  ) {  }

  ngOnInit() {
    this.multiStepServ.setSteps(of(this.steps));
  }

  ngOnDestroy() { }

  get showIndicator(): boolean {
    return this.multiStepServ.showIndicator;
  }
}
